import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

interface ThreadIntakeStartActionsProps {
  showIntakeRow: boolean
  showProceedWithoutMedia: boolean
  showRetry: boolean
  showArmedProceed: boolean
  onProceedWithoutMedia: () => void
  onKeepTalking: () => void
  onRetry: () => void
  onArmedProceedWithoutMedia: () => void
}

export function ThreadIntakeStartActions(props: ThreadIntakeStartActionsProps) {
  const {
    showIntakeRow,
    showProceedWithoutMedia,
    showRetry,
    showArmedProceed,
    onProceedWithoutMedia,
    onKeepTalking,
    onRetry,
    onArmedProceedWithoutMedia,
  } = props

  const { t } = useTranslation('app')

  if (showIntakeRow) {
    return (
      <div
        className="flex max-w-prose flex-wrap items-center gap-2"
        data-testid="thread-intake-start-actions"
      >
        {showProceedWithoutMedia ? (
          <Button
            type="button"
            variant="primary"
            size="sm"
            className="text-sm"
            data-testid="thread-intake-proceed-without-media"
            onClick={onProceedWithoutMedia}
          >
            {t('threads.detail.command.proceedWithoutMedia')}
          </Button>
        ) : null}
        {showRetry ? (
          <Button
            type="button"
            variant="primary"
            size="sm"
            className="text-sm"
            data-testid="thread-intake-retry"
            onClick={onRetry}
          >
            {t('retry', { ns: 'common' })}
          </Button>
        ) : null}
        <Button
          type="button"
          size="sm"
          variant="ghost"
          data-testid="thread-intake-keep-talking"
          onClick={onKeepTalking}
        >
          {t('threads.detail.command.keepTalking')}
        </Button>
      </div>
    )
  }

  if (showArmedProceed) {
    return (
      <div
        className="flex max-w-prose flex-wrap items-center gap-2"
        data-testid="thread-intake-start-actions"
      >
        <Button
          type="button"
          variant="primary"
          size="sm"
          className="text-sm"
          data-testid="thread-armed-proceed-without-media"
          onClick={onArmedProceedWithoutMedia}
        >
          {t('threads.detail.command.proceedWithoutMedia')}
        </Button>
      </div>
    )
  }

  return null
}
